<div class="content">
  <div class="wrapper">

    <div *ngIf="!isMock" fxLayout="row" fxLayout.xs="column" fxLayoutGap="1%">
      <mat-card class="content-header" fxFlex="75%">
        <mat-card-header>
          <div class="material-icons" mat-card-avatar>people</div>
          <mat-card-title>{{communityh !== undefined ? communityh : ''}}</mat-card-title>
        </mat-card-header>
        <!-- <mat-card-subtitle></mat-card-subtitle> -->
        <mat-divider></mat-divider>
        <mat-card-content style="white-space: pre-line;">
          {{communityt !== undefined ? communityt : ''}}
        </mat-card-content>
      </mat-card>

      <mat-card fxFlex="24%">
        <mat-card-header>
          <div class="material-icons" mat-card-avatar>insert_chart_outlined</div>
          <mat-card-title>Meine Strombilanz</mat-card-title>
        </mat-card-header>
        <mat-divider></mat-divider>
        <mat-card-content>
          Wieviel Strom hat meine Community produziert bzw.
          verbraucht? Wie autark ist meine Region?
        </mat-card-content>
        <mat-card-actions fxLayoutAlign="center center">
          <a class="loginbtn" mat-raised-button routerLink="/meine-strombilanz">ansehen</a>
        </mat-card-actions>
      </mat-card>
    </div>


    <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="1%">

      <div fxFlex="24%">

        <mat-card>
          <mat-card-header>
            <div class="material-icons" mat-card-avatar>people</div>
            <mat-card-title>Aktivität der Community</mat-card-title>
            <mat-card-subtitle>der letzten 24 Stunden</mat-card-subtitle>
          </mat-card-header>
          <mat-divider></mat-divider>
          <mat-card-content style="text-align: center">
            <rsp-loading-wrapper [state]="chartStateCommunityActivity">
              <rsp-community-activity-chart
                [color1]="thccolor0"
                [color2]="thccolor1"
                [color3]="thccolor2"
                [color4]="thccolor3"
                [color5]="thccolor4"
                [data]="_tenantCommunityTotalsDTO"
                [hasError]="chartStateCommunityActivity.hasError"
                [enableExport]="chartStateCommunityActivity.isReady"
                [displayPreviousDay]="compareWithYesterday">
              </rsp-community-activity-chart>
            </rsp-loading-wrapper>
            <mat-slide-toggle (change)="onChangeCommunityActivityChart($event)"
                              *ngIf="!chartStateCommunityActivity.hasError && !chartStateCommunityActivity.hasNoData">
              mit Vortag vergleichen
            </mat-slide-toggle>
          </mat-card-content>
        </mat-card>


      </div>
      <div fxFlex="50%">

        <mat-card>
          <mat-card-content fxFlex="1 1" fxFlex.sm="1 1" fxFlex.xs="1 1" fxLayout="row" style="height:600px">
            <rsp-map
              [mappoints]="mappoints"
              [markers]="markers"
              [regions]="regions"
              [mapRadiusKm]="tenant.getInfo().mapRadiusKm"
              fxFlex="1 1 100%">
            </rsp-map>
          </mat-card-content>
        </mat-card>

        <mat-card>
          <mat-card-header>
            <div class="material-icons" mat-card-avatar>timeline</div>
            <mat-card-title>Community Erzeugung und Verbrauch</mat-card-title>
          </mat-card-header>
          <mat-divider></mat-divider>
          <mat-card-content>
            <rsp-date-selection [formGroup]="dateSelectionFormGroup"></rsp-date-selection>
            <rsp-loading-wrapper [state]="chartStateCommunityProductionSupply">
              <rsp-community-erzeugung-verbrauch-chart
                [color1]="thccolor0"
                [color2]="thccolor1"
                [color3]="thccolor2"
                [color4]="thccolor3"
                [hasError]="chartStateCommunityProductionSupply.hasError"
                [enableExport]="chartStateCommunityProductionSupply.isReady"
                [data]="_tenantCommunityDatasDTO">
              </rsp-community-erzeugung-verbrauch-chart>
            </rsp-loading-wrapper>

          </mat-card-content>
        </mat-card>

      </div>
      <div fxFlex="24%">

        <mat-card *ngIf="powerplants.length > 0">
          <mat-card-header>
            <div class="material-icons" mat-card-avatar>battery_charging_full</div>
            <mat-card-title>Kraftwerke</mat-card-title>
          </mat-card-header>
          <mat-divider></mat-divider>
          <mat-card-content>
            <rsp-carousel [productionSites]="powerplants">

            </rsp-carousel>
          </mat-card-content>

        </mat-card>


        <br *ngIf="powerplants.length > 0">

        <mat-card>
          <mat-card-header>
            <div class="material-icons" mat-card-avatar>power</div>
            <mat-card-title>Community Autarkie-Grad {{autarkie}}</mat-card-title>
          </mat-card-header>
          <mat-divider></mat-divider>
          <mat-card-content>
            <mat-form-field *ngIf="displayCommunityAutarkie(chartStateCommunitySelfSupply)"
                            style="width:100%">
              <mat-select [formControl]="autarkieGradFormControl" required style="width:100%">
                <mat-option *ngFor="let option of autarkieGradOptions"
                            [value]="option.value"
                            [disabled]="option.disabled">
                  {{option.option}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <rsp-loading-wrapper [state]="chartStateCommunitySelfSupply">
              <rsp-community-autarkie-grad-chart
                [style.visibility]="displayCommunityAutarkie(chartStateCommunitySelfSupply) ? 'visible' : 'hidden'"
                [color1]="thccolor0"
                [color2]="thccolor1"
                [color3]="thccolor2"
                [color4]="thccolor3"
                [color5]="thccolor4"
                (chartEvent)="onChartEvent($event)"
                [data]="_tenantCommunityUsageDTO"
                [hasError]="chartStateCommunitySelfSupply.hasError"
                [hasNoData]="chartStateCommunitySelfSupply.hasNoData">
              </rsp-community-autarkie-grad-chart>
            </rsp-loading-wrapper>
          </mat-card-content>
        </mat-card>

      </div>
    </div>


  </div>

</div>
